import {
    Injectable,
    Signal,
    WritableSignal,
    computed,
    signal,
} from '@angular/core';
import { IUser } from '@interface/user.interface';

@Injectable({
    providedIn: 'root',
})
export class ManageScopeService<T extends IUser> {
    private state: WritableSignal<T> = signal({} as T);

    public set<K extends keyof T>(key: K, data: T[K]) {
        this.state.update((current) => ({ ...current, [key]: data }));
    }

    public setState(partial: Partial<T>): void {
        this.state.update((current) => ({ ...current, ...partial }));
    }

    public select<K extends keyof T>(key: K): Signal<T[K]> {
        return computed(() => this.state()[key]);
    }
}
